import React from "react";
import { NAV_LINKS } from "@/lib/site";

const NavItem = ({ link, isActive, onSelect }) => (
  <button
    type="button"
    data-testid={`header-nav-${link.id}-link`}
    onClick={() => onSelect(link.id)}
    className="relative py-2 text-sm font-medium text-slate-700 transition-colors hover:text-[#0f6e73] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1aa3a8]"
  >
    {link.label}
    <span
      className={`absolute -bottom-0.5 left-0 h-[2px] bg-[#1aa3a8] transition-[width] duration-200 ${
        isActive ? "w-full" : "w-0"
      }`}
    />
  </button>
);

export const DesktopNav = ({ active, onSelect }) => (
  <nav aria-label="Main navigation" className="hidden items-center gap-6 lg:flex">
    {NAV_LINKS.map((link) => (
      <NavItem key={link.id} link={link} isActive={active === link.id} onSelect={onSelect} />
    ))}
  </nav>
);
